import React from 'react'
import styled from 'styled-components'
import {Link as CoreLink, Box} from '@miro-site/core'
import HeaderContainer from './HeaderContainer'
import {IHeader} from '../api/interfaces'

const Link = styled(CoreLink).attrs(({theme: {header: {bottomLinks}}}) => ({
  $variant: bottomLinks.link.variant,
  $color: bottomLinks.link.color,
  $size: bottomLinks.link.size,
  withArrow: bottomLinks.link.withArrow,
  $styles: {
    marginRight: bottomLinks.gutter,
    borderBottom: bottomLinks.link.border,
  },
}))``

const Wrapper = styled(Box).attrs(({theme: {header}}) => ({
  $styles: {
    height: header.bottomLinks.height,
    paddingTop: header.bottomLinks.paddingTop,
    paddingBottom: header.bottomLinks.paddingBottom,
    borderTop: header.secondaryNavigation.stroke,
    background: header.bottomLinks.background,
  },
}))`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 10;
`

type BottomLinksProps = Pick<IHeader, 'bottomLinks'> & Record<string, unknown>

const BottomLinks = ({bottomLinks, ...restProps}: BottomLinksProps): React.ReactElement => {
  return (
    <Wrapper {...restProps}>
      <HeaderContainer>
        {bottomLinks.map(l => (
          <Link key={l.title} href={l.path}>
            {l.title}
          </Link>
        ))}
      </HeaderContainer>
    </Wrapper>
  )
}

export default Object.assign(BottomLinks, {Link: Link})
